module.exports = __webpack_public_path__ + "img/product5.8ceae8db.png";